"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CircularProgress_1 = tslib_1.__importDefault(require("@mui/material/CircularProgress"));
const TextField_1 = tslib_1.__importDefault(require("@mui/material/TextField"));
function AutocompleteInput({ fullWidth = true, loading = false, LoadingProps: loadingPropsProp, LoadingComponent = CircularProgress_1.default, InputProps = {}, ...rest }) {
    const loadingProps = { color: "inherit", size: 20 };
    return (react_1.default.createElement(TextField_1.default, { fullWidth: fullWidth, ...rest, InputProps: {
            ...InputProps,
            endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                loading ? react_1.default.createElement(LoadingComponent, { ...loadingProps }) : null,
                InputProps.endAdornment || null)),
        }, variant: "outlined" }));
}
exports.default = AutocompleteInput;
